import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import '../Registration.css';
import './Schedule.css';
import './ScheduleAI.css';
import { host } from '../../App';
import { UserOutlined, LogoutOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Menu, Dropdown, Row } from 'antd';
import { Link } from "react-router-dom";
import { format } from 'date-fns';
import { LocalFireDepartment } from '@mui/icons-material';

function Schedule(props) {
  var token = (window.localStorage.getItem("acessToken"));
  const user = JSON.parse(window.localStorage.getItem("Name"));

  // declare all variables in order to send to js file
  var [shift, setShift] = useState("Morning_Operators");
  var [Date1, setDate1] = useState(new Date());
  const [Date2, setDate2] = useState(Date1.toISOString().slice(0, 10));
  const [Morning_operators, setMorning_operators] = useState([]);
  const [Machine_list, setMachine_list] = useState([]);
  const [part_dataset, setpart_dataset] = useState([]);
  const [Area, setArea] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // AI-related states
  const [showAIModal, setShowAIModal] = useState(false);
  const [pastedData, setPastedData] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [parsedResults, setParsedResults] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // For image upload

  const getCurrentDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  const defaultData = () => {
    const Date2 = getCurrentDate();
    return [
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', Produced: '', work_station: '', Scrap: '', Supervisor_notes: '', Operator_2: '', matchConfidence: null, productType: '' },
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', Produced: '', work_station: '', Scrap: '', Supervisor_notes: '', Operator_2: '', matchConfidence: null, productType: '' },
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', Produced: '', work_station: '', Scrap: '', Supervisor_notes: '', Operator_2: '', matchConfidence: null, productType: '' },
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', Produced: '', work_station: '', Scrap: '', Supervisor_notes: '', Operator_2: '', matchConfidence: null, productType: '' },
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', Produced: '', work_station: '', Scrap: '', Supervisor_notes: '', Operator_2: '', matchConfidence: null, productType: '' }
    ];
  };

  const [data, setData] = useState(defaultData);

  useEffect(() => {
    const savedData = window.localStorage.getItem('data');
    setTimeout(() => {
      if (savedData) {
        setData(JSON.parse(savedData));
      }
    }, 1000)
  }, []);

  const saveDraft = () => {
    try {
      window.localStorage.setItem('data', JSON.stringify(data));
    } catch (error) {
      console.error('Error saving draft:', error);
    }
  };

  const queryParams = {
    shift: shift,
    token: token,
    Date: Date2,
    user: user,
    Department: Area
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setDate1(new Date(), 10);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (shift.length > 1) {
      Axios.get(`http://localhost:3001/api/employees`, { params: queryParams })
        .then((data) => {
          const filteredEmployees = data.data.filter((employee) => employee.Name && employee.Name.length > 1);
          setMorning_operators(filteredEmployees);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
  }, [shift]);

  useEffect(() => {
    Axios.get(`http://localhost:3001/realapi/get/Machines/${token}`).then((data) => {
      setMachine_list(data.data)
    });
  }, [])

  useEffect(() => {
    Axios.get(`http://localhost:3001/realapi/get/part_dataset/${token}`).then((data) => {
      setpart_dataset(data.data)
    });
  }, [])

  const area = () => {
    if (Area == "Rigid") {
      console.log("rigid called");
      Axios.get(`http://localhost:3001/realapi/get/Rigidpart_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
      });
      Axios.get(`http://localhost:3001/realapi/get/RigidMachines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
    if (Area == "Flex") {
      Axios.get(`http://localhost:3001/realapi/get/Flexpart_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
      });
      Axios.get(`http://localhost:3001/realapi/get/FlexMachines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
    if (Area == "Others") {
      Axios.get(`http://localhost:3001/realapi/get/part_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
        console.log(data.data);
      });
      Axios.get(`http://localhost:3001/realapi/get/Machines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
  }

  useEffect(() => {
    const newData = data.map((line) => ({ ...line, Date: Date2 }));
    setData(newData);
  }, [Date2])

  const submitValue = (e, index) => {
    const value = e.target.value.trim().replace(/\s+/g, ' ');
    const partDetails = part_dataset.find(
      (x) => x.Part_internalNo.trim().replace(/\s+/g, ' ') === value
    );

    if (!partDetails) {
      console.warn("No part found for:", value);
      return;
    }

    const newData = [...data];
    newData[index].Part_internalNo = value;
    newData[index].Customer = partDetails.Customer;
    newData[index].PartNo = partDetails.PartNo;
    newData[index].Part_description = partDetails.Part_description;

    setData(newData);
    saveDraft();
  };

  const addLines = () => {
    if (data.length < 15) {
      const newData = [...data];
      for (let i = 0; i < 5; i++) {
        newData.push({ Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', Produced: '', work_station: '', Supervisor_notes: '', Operator_2: '', matchConfidence: null, productType: '' });
      }
      setData(newData);
    } else {
      window.alert("Lines Reached maximum limit")
    }
  }

  const addNewRow = (index, operatorName, work_station) => {
    const newData = [...data];
    const newRow = { Operator: operatorName, Part_internalNo: '', Customer: '', PartNo: '', Part_description: '', Target: '', Produced: '', work_station: work_station, Operator_2: '', Supervisor_notes: '', matchConfidence: null, productType: '' };
    newData.splice(index + 1, 0, newRow);
    setData(newData);
  };

  const deleteRow = (index) => {
    if (data.length <= 1) {
      window.alert("Cannot delete the last row");
      return;
    }
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
    saveDraft();
  };

  useEffect(() => {
    const initialData = Morning_operators.map((operator, idx) => ({
      id: idx + 1,
      Operator: operator.Name,
      Part_internalNo: '',
      Customer: '',
      PartNo: '',
      Part_description: '',
      Target: '',
      Produced: '',
      work_station: '',
      Operator_2: '',
      Supervisor_notes: '',
      matchConfidence: null,
      productType: ''
    }));
    setData(initialData);
  }, [Morning_operators]);

  const handleLogout = () => {
    window.localStorage.removeItem("acessToken");
    window.localStorage.removeItem("Name");
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    props.history.push('/');
  }

  const userMenu = (
    <Menu>
      <Menu.Item key="logout">
        <a onClick={handleLogout} href="/">
          <LogoutOutlined />
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  const submitdata = () => {
    const filteredData = [];
    data.forEach(item => {
      if (
        item.Operator &&
        item.Part_internalNo &&
        item.PartNo &&
        item.Customer &&
        item.Part_description
      ) {
        const newData = [
          Date2,
          item.Operator,
          item.Part_internalNo,
          item.PartNo,
          item.Customer,
          item.Part_description,
          item.Target,
          item.work_station,
          item.Supervisor_notes,
          item.Operator_2,
          user,
          getFormattedDateTime(Date1),
          shift,
          item.Produced // New Column Added
        ];
        filteredData.push(newData);
      }
    });

    setIsLoading(true);
    setTimeout(() => {
      Axios.post(`http://localhost:3001/realapi/Schedule_entry`, { filteredData, token }).then((response) => {
        if (response.status === 200) {
          window.alert(response.data.message);
          setIsLoading(false);
          window.location.reload();
        }
      })
        .catch(error => {
          window.alert("Error Occured")
          setIsLoading(false);
        });
    }, 2000)
  }

  const getFormattedDateTime = (date) => {
    return format(date, 'yyyy-MM-dd HH:mm:ss');
  };

  let lastOperator = '';
  let lastColor = 'light';

  const getStripedClass = (currentOperator) => {
    if (currentOperator !== lastOperator) {
      lastColor = lastColor === 'light' ? 'dark' : 'light';
      lastOperator = currentOperator;
    }
    return lastColor;
  };

  // AI PARSING FUNCTIONS
  const processAIData = async () => {
    // Branch logic: If a file is selected, send via FormData for OCR. Otherwise, send text.
    if (!selectedFile && !pastedData.trim()) {
      alert('Please paste data or upload an image first');
      return;
    }

    setIsProcessing(true);

    try {
      console.log('=== FRONTEND: Starting AI Parse ===');
      console.log('Operators:', Morning_operators.length);
      console.log('Parts:', part_dataset.length);

      // Optimize payload
      const optimizedParts = part_dataset.map(p => ({
        i: p.Part_internalNo,
        n: p.PartNo,
        d: p.Part_description,
        c: p.Customer
      }));

      let response;

      if (selectedFile) {
        // ==================== IMAGE UPLOAD ROUTE ====================
        console.log('Sending image for OCR...');
        const formData = new FormData();
        formData.append('scheduleImage', selectedFile);
        formData.append('token', token);
        formData.append('operators', JSON.stringify(Morning_operators.map(op => op.Name)));
        formData.append('parts', JSON.stringify(optimizedParts));
        formData.append('machines', JSON.stringify(Machine_list.map(m => m.Machines)));
        formData.append('useAI', 'true');

        response = await Axios.post(`http://localhost:3001/realapi/parse-schedule-image`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        // ==================== TEXT PASTE ROUTE ====================
        console.log('Sending raw text...');
        response = await Axios.post(`http://localhost:3001/realapi/parse-schedule-data`, {
          pastedData,
          token,
          operators: Morning_operators.map(op => op.Name),
          parts: optimizedParts,
          machines: Machine_list.map(m => m.Machines),
          useAI: true
        });
      }

      console.log('Response received:', response.data);
      console.log('Parsed data count:', response.data.parsedData?.length);

      if (!response.data.parsedData || response.data.parsedData.length === 0) {
        alert('No data could be parsed. Please check the format/image clarity.\n\nCheck console for details.');
        setIsProcessing(false);
        return;
      }

      setParsedResults(response.data.parsedData);
      setShowConfirmation(true);
      setIsProcessing(false);
    } catch (error) {
      console.error('Error processing data:', error);
      console.error('Error response:', error.response?.data);

      let errorMessage = 'Error processing data. ';

      if (error.response?.status === 413) {
        errorMessage += 'Data too large. Please contact your administrator to increase server payload limit.';
      } else if (error.response?.data?.message) {
        errorMessage += error.response.data.message;
      } else {
        errorMessage += error.message;
      }

      alert(errorMessage + '\n\nCheck console for details.');
      setIsProcessing(false);
    }
  };

  const confirmAIResults = () => {
    const newData = parsedResults.map(result => ({
      Date: Date2,
      Operator: result.operator,
      Part_internalNo: result.partInternalNo,
      PartNo: result.partNo,
      Customer: result.customer,
      Part_description: result.partDescription,
      Target: result.target,
      Produced: result.target, // Produced automatically matches Target
      work_station: result.workStation,
      Supervisor_notes: result.notes || '',
      Operator_2: result.operator2 || '',
      matchConfidence: result.matchConfidence,
      productType: result.productType
    }));

    setData(newData);
    saveDraft();
    setShowAIModal(false);
    setShowConfirmation(false);
    setPastedData('');
    setParsedResults([]);
    setSelectedFile(null); // Reset file input
  };

  // Update a specific parsed result
  const updateParsedResult = (index, field, value) => {
    const newResults = [...parsedResults];
    newResults[index][field] = value;
    setParsedResults(newResults);
  };

  // Change part match for a specific row
  const changePartMatch = (index, productType) => {
    const newResults = [...parsedResults];
    const result = newResults[index];

    // Filter parts by type
    let filteredParts = part_dataset;
    if (productType === 'Flex') {
      filteredParts = part_dataset.filter(part =>
        part.Part_internalNo.includes('-F') ||
        part.Part_description.toLowerCase().includes('flex')
      );
    } else if (productType === 'Rigid') {
      filteredParts = part_dataset.filter(part =>
        !part.Part_internalNo.includes('-F') &&
        !part.Part_description.toLowerCase().includes('flex')
      );
    }

    // Find best match with filtered parts
    const searchTerm = result.originalPartDescription || result.partDescription;
    const bestMatch = findBestPartMatch(searchTerm, filteredParts);

    if (bestMatch) {
      newResults[index] = {
        ...result,
        partInternalNo: bestMatch.Part_internalNo,
        partNo: bestMatch.PartNo,
        customer: bestMatch.Customer,
        partDescription: bestMatch.Part_description,
        productType: productType,
        matchConfidence: 'high'
      };
    } else {
      newResults[index].productType = productType;
    }

    setParsedResults(newResults);
  };

  // Simple local part matching (client-side)
  const findBestPartMatch = (searchTerm, partsList) => {
    const normalized = searchTerm.toLowerCase().trim();

    // Exact match
    for (let part of partsList) {
      if (part.Part_description.toLowerCase() === normalized ||
        part.Part_internalNo.toLowerCase() === normalized) {
        return part;
      }
    }

    // Partial match
    for (let part of partsList) {
      if (part.Part_description.toLowerCase().includes(normalized) ||
        normalized.includes(part.Part_description.toLowerCase())) {
        return part;
      }
    }

    return null;
  };

  const toggleProductType = (index, type) => {
    const newData = [...data];
    newData[index].productType = type;

    const searchTerm = newData[index].Part_description || newData[index].Part_internalNo;
    if (searchTerm) {
      const filteredParts = part_dataset.filter(part => {
        if (type === 'Flex') {
          return part.Part_internalNo.includes('-F') || part.Part_description.toLowerCase().includes('flex');
        } else if (type === 'Rigid') {
          return !part.Part_internalNo.includes('-F') && !part.Part_description.toLowerCase().includes('flex');
        }
        return true;
      });

      const bestMatch = findBestMatch(searchTerm, filteredParts);
      if (bestMatch) {
        newData[index].Part_internalNo = bestMatch.Part_internalNo;
        newData[index].PartNo = bestMatch.PartNo;
        newData[index].Customer = bestMatch.Customer;
        newData[index].Part_description = bestMatch.Part_description;
      }
    }

    setData(newData);
    saveDraft();
  };

  const findBestMatch = (searchTerm, dataset) => {
    const normalized = searchTerm.toLowerCase().trim();

    for (let item of dataset) {
      const itemDesc = item.Part_description.toLowerCase();
      const itemInternal = item.Part_internalNo.toLowerCase();

      if (itemDesc === normalized || itemInternal === normalized) {
        return item;
      }
    }

    for (let item of dataset) {
      const itemDesc = item.Part_description.toLowerCase();
      if (itemDesc.includes(normalized) || normalized.includes(itemDesc)) {
        return item;
      }
    }

    return null;
  };

  const getConfidenceClass = (confidence) => {
    if (confidence === 'exact') return 'ai-match-exact';
    if (confidence === 'high') return 'ai-match-high';
    if (confidence === 'medium') return 'ai-match-medium';
    if (confidence === 'low') return 'ai-match-low';
    return '';
  };

  return (
    <div className="schedule-ai-container">
      <br />
      <h1>CREATE NEW SCHEDULE</h1>
      <br />

      <div className="row schedule-ai-controls">
        <div className="col-2">
          <label><b><h4>Select Shift</h4></b></label>
          <div className="row">
            <select
              name="shift"
              className="form-control form-rounded"
              placeholder="Select Shift"
              value={shift}
              onChange={(e) => { setShift(e.target.value) }}
            >
              <option value="Morning_Operators', 'Night_Operators', 'Woodshop">All Employees</option>
              <option value="Morning_Operators">1st Shift</option>
              <option value="Night_Operators">2nd Shift</option>
              <option value="Woodshop">Woodshop/Upholstery</option>
            </select>
          </div>
        </div>

        <div className="col-2">
          <label><b><h4>Select Department</h4></b></label>
          <select type="select" className="form-control form-rounded" id='Area' placeholder="Area" onChange={(e) => {
            setArea(e.target.value)
          }} onClick={area} onKeyDown={area} name="area">
            <option value="Others">Others</option>
            <option value="Flex">Flex</option>
            <option value="Rigid">Rigid</option>
          </select>
        </div>

        <div className="col-2">
          <label><b><h4>Date</h4></b></label>
          <input type="date" className="form-control form-rounded" placeholder="Date" name="Date" id='date' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => {
            setDate2(e.target.value)
          }} required />
        </div>

        <div className="col-2">
          <label><b><h4>Reset Schedule</h4></b></label>
          <input type="button" className="form-control form-rounded" onClick={(e) => {
            window.localStorage.removeItem("data");
            window.alert("Cleared!");
          }} value="Clear All" />
        </div>

        <div className="col-2">
          <label><b><h4>AI Import</h4></b></label>
          <button
            className="btn btn-info form-control ai-import-btn"
            onClick={() => setShowAIModal(true)}
          >
            🤖 Paste & Parse Data
          </button>
        </div>
      </div>

      <br />
      <br />

      {data.map((line, index) => {
        const stripClass = getStripedClass(line.Operator);
        const confidenceClass = getConfidenceClass(line.matchConfidence);

        return (
          <div key={index} className={`row schedule-ai-row ${stripClass} ${confidenceClass}`}>
            <div className="col">
              <input
                type="text"
                className="form-control form-rounded"
                onChange={(e) => {
                  const newData = [...data];
                  newData[index].Operator = e.target.value;
                  setData(newData);
                }}
                onBlur={saveDraft}
                list="operatorList"
                id="operators"
                value={line.Operator}
                placeholder="Enter Operator"
              />
              <datalist id="operatorList">
                <option key="empty-option"></option>
                {Morning_operators.map((x) => (
                  <option key={x.Name}>{x.Name}</option>
                ))}
              </datalist>
            </div>

            <div className="col-2">
              <br />
              <div className="ai-part-input-wrapper">
                <input
                  type="text"
                  className="form-control form-rounded"
                  onChange={(e) => {
                    const newData = [...data];
                    newData[index].Part_internalNo = e.target.value;
                    setData(newData);
                  }}
                  onBlur={(e) => submitValue(e, index)}
                  value={data[index].Part_internalNo}
                  list="InternalPartNo"
                  id="operator"
                  placeholder="Enter Internal Part No"
                />
              </div>
              <div className="scrollbar">
                <datalist id="InternalPartNo">
                  <option key="empty-option"></option>
                  {part_dataset.map((x, idx) => (
                    <option key={x.Part_internalNo + idx}>{x.Part_internalNo}</option>
                  ))}
                </datalist>
              </div>
            </div>

            <div className="col-1">
              <label><b><h3></h3></b></label>
              <input
                type="text"
                className="form-control form-rounded"
                onChange={(e) => {
                  if (!/^\d*$/.test(e.target.value)) {
                    alert("Numbers only");
                    return;
                  }
                  const newData = [...data];
                  newData[index].Target = e.target.value;
                  setData(newData);
                }}
                onBlur={saveDraft}
                value={data[index].Target}
                placeholder="Target"
                name="target"
                required
              />
            </div>

            {/* NEW Produced Column */}
            <div className="col-1">
              <label><b><h3></h3></b></label>
              <input
                type="text"
                className="form-control form-rounded"
                onChange={(e) => {
                  if (!/^\d*$/.test(e.target.value)) {
                    alert("Numbers only");
                    return;
                  }
                  const newData = [...data];
                  newData[index].Produced = e.target.value;
                  setData(newData);
                }}
                onBlur={saveDraft}
                value={data[index].Produced}
                placeholder="Produced"
                name="produced"
              />
            </div>

            <div className="col">
              <input
                type="text"
                className="form-control form-rounded"
                onChange={(e) => {
                  const newData = [...data];
                  newData[index].work_station = e.target.value;
                  setData(newData);
                }}
                onBlur={saveDraft}
                placeholder="Work Station"
                value={line.work_station}
                list="Work_station"
              />
              <datalist id="Work_station">
                <option key="empty-option"></option>
                {Machine_list.map((x, idx) => (
                  <option key={x.Machines + idx}>{x.Machines}</option>
                ))}
              </datalist>
            </div>

            <div className="col-1">
              <input
                type="text"
                className="form-control form-rounded"
                onChange={(e) => {
                  const newData = [...data];
                  newData[index].Operator_2 = e.target.value;
                  setData(newData);
                }}
                onBlur={saveDraft}
                value={data[index].Operator_2}
                placeholder="Operator-2 (Optional)"
                name="operator_2"
                list="operatorList"
              />
            </div>

            <div className="col-2">
              <textarea
                className="form-control form-rounded"
                onChange={(e) => {
                  const newData = [...data];
                  newData[index].Supervisor_notes = e.target.value;
                  setData(newData);
                }}
                onBlur={saveDraft}
                placeholder="Supervisor Notes"
                name="Supervisor_notes"
              />
            </div>

            <div className="col-sm-1">
              <button
                key={line.Operator}
                onClick={() => addNewRow(index, line.Operator, line.work_station)}
                className="form-control form-rounded"
              >
                Add {(line.Operator).split(0, 10)}
              </button>
            </div>

            <div className="col-sm-1">
              <button
                onClick={() => deleteRow(index)}
                className="form-control btn-outline-danger form-rounded"
                style={{ borderColor: '#dc3545', color: '#dc3545' }}
              >
                🗑️
              </button>
            </div>
          </div>
        )
      })}

      <button onClick={submitdata} className="btn btn-primary">Submit</button>
      <button onClick={addLines} className="btn btn-success">Add Row</button>
      <Link to="/RetrieveData">
        <button type="button" className="btn btn-success">Read Table</button>
      </Link>
      <Link to="/ActivityLog">
        <button type="button" className="btn btn-warning">Activity Log</button>
      </Link>
      <Link to="/Scheduling">
        <button type="button" className="btn btn-secondary">Scheduling</button>
      </Link>

      {/* AI Modal */}
      {showAIModal && (
        <div className="ai-modal-overlay" onClick={() => setShowAIModal(false)}>
          <div className="ai-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="ai-modal-header">
              <h3>🤖 AI-Powered Data Import</h3>
              <button className="ai-modal-close" onClick={() => setShowAIModal(false)}>×</button>
            </div>
            <div className="ai-modal-body">
              <p className="ai-help-text">
                Paste your schedule data <strong>OR</strong> upload an image. The AI will automatically:
                <br />• Match operator names
                <br />• Identify part numbers and descriptions
                <br />• Detect Rigid/Flex products
                <br />• Parse targets and work stations
              </p>

              {/* IMAGE UPLOAD SECTION */}
              <div className="ai-upload-container">
                <label><b><UploadOutlined /> Upload Image (OCR):</b></label>
                <br />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                  className="form-control-file"
                />
                {selectedFile && (
                  <div className="ai-file-selected">
                    Selected: <strong>{selectedFile.name}</strong>
                    <button className="ai-remove-file" onClick={() => setSelectedFile(null)}>x</button>
                  </div>
                )}
              </div>

              <div style={{ textAlign: 'center', margin: '10px 0', fontWeight: 'bold' }}> - OR - </div>

              {/* TEXT PASTE SECTION */}
              <textarea
                className="ai-paste-area"
                value={pastedData}
                onChange={(e) => setPastedData(e.target.value)}
                placeholder="Paste your text data here... (Alternatively, upload an image above)"
                rows={5}
              />
            </div>
            <div className="ai-modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowAIModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={processAIData}
                disabled={isProcessing}
              >
                {isProcessing ? 'Processing...' : '🧠 Parse with AI'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="ai-modal-overlay">
          <div className="ai-modal-content ai-confirmation-modal">
            <div className="ai-modal-header">
              <h3>✅ Review and Confirm Matches</h3>
              <button className="ai-modal-close" onClick={() => setShowConfirmation(false)}>×</button>
            </div>
            <div className="ai-modal-body">
              <div className="ai-legend">
                <span className="ai-legend-item"><span className="ai-legend-box ai-match-exact"></span> Exact Match</span>
                <span className="ai-legend-item"><span className="ai-legend-box ai-match-high"></span> High Confidence</span>
                <span className="ai-legend-item"><span className="ai-legend-box ai-match-medium"></span> Medium Confidence</span>
                <span className="ai-legend-item"><span className="ai-legend-box ai-match-low"></span> Low - Please Review</span>
              </div>

              <p className="ai-help-text">
                <strong>Review each match below.</strong> Use the <strong>dropdown</strong> to change the part if the match is wrong. Edit any field as needed.
              </p>

              <div className="ai-results-table-container">
                <table className="table table-bordered ai-editable-table">
                  <thead>
                    <tr>
                      <th>Operator</th>
                      <th>Original Input</th>
                      <th>Matched Part</th>
                      <th>Internal No</th>
                      <th>Customer</th>
                      <th>Target</th>
                      <th>Match</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parsedResults.map((result, idx) => (
                      <tr key={idx} className={getConfidenceClass(result.matchConfidence)}>
                        <td>
                          <input
                            type="text"
                            value={result.operator}
                            onChange={(e) => updateParsedResult(idx, 'operator', e.target.value)}
                            list="operatorListModal"
                            className="form-control form-control-sm"
                          />
                          {result.originalOperatorInput && result.originalOperatorInput !== result.operator && (
                            <small className="text-muted d-block">
                              (from: {result.originalOperatorInput})
                            </small>
                          )}
                        </td>
                        <td>
                          <small className="text-muted">{result.originalPartDescription}</small>
                        </td>
                        <td>
                          <select
                            value={result.partInternalNo}
                            onChange={(e) => {
                              const selectedPart = part_dataset.find(p => p.Part_internalNo === e.target.value);
                              if (selectedPart) {
                                updateParsedResult(idx, 'partInternalNo', selectedPart.Part_internalNo);
                                updateParsedResult(idx, 'partNo', selectedPart.PartNo);
                                updateParsedResult(idx, 'customer', selectedPart.Customer);
                                updateParsedResult(idx, 'partDescription', selectedPart.Part_description);
                                updateParsedResult(idx, 'matchConfidence', 'exact');
                              }
                            }}
                            className="form-control form-control-sm"
                          >
                            <option value="">-- Select Part --</option>
                            {part_dataset
                              .map((part, pidx) => (
                                <option key={pidx} value={part.Part_internalNo}>
                                  {part.Part_description} ({part.Part_internalNo})
                                </option>
                              ))
                            }
                          </select>
                          <small className="text-muted d-block mt-1">{result.partDescription}</small>
                        </td>
                        <td>
                          <small>{result.partInternalNo || '—'}</small>
                        </td>
                        <td>
                          <small>{result.customer || '—'}</small>
                        </td>
                        <td>
                          <input
                            type="number"
                            value={result.target}
                            onChange={(e) => updateParsedResult(idx, 'target', e.target.value)}
                            className="form-control form-control-sm"
                            style={{ width: '70px' }}
                          />
                        </td>
                        <td>
                          <span className={`badge ${result.matchConfidence === 'exact' ? 'bg-success' :
                            result.matchConfidence === 'high' ? 'bg-info' :
                              result.matchConfidence === 'medium' ? 'bg-warning' : 'bg-danger'
                            }`}>
                            {result.matchConfidence}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <datalist id="operatorListModal">
                {Morning_operators.map((x) => (
                  <option key={x.Name}>{x.Name}</option>
                ))}
              </datalist>
            </div>
            <div className="ai-modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowConfirmation(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-success"
                onClick={confirmAIResults}
              >
                ✓ Apply to Schedule
              </button>
            </div>
          </div>
        </div>
      )}

      {isLoading && (
        <div className='overlay'>
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Schedule